import React, { useEffect, useState } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Column } from "primereact/column";
import * as Fa from "react-icons/fa";
import { DataTable } from "primereact/datatable";
import Axios from "../../api/Axios";
import Loader from "../../Components/Loader";
import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Paginator } from "primereact/paginator";
import { RadioButton } from "primereact/radiobutton";
// import "primeflex/primeflex.css";

const Help = () => {
    const [loader, setLoader] = useState(false);
    const [obj, setObj] = useState([]);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [search, setSearch] = useState("");
    const [category, setCategory] = useState(null);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(3);
    const [videos, setVideos] = useState([]);
    const [manualType, setManualType] = useState("PDF");
    const UserPDFManualsApi = async () => {
        setLoader(true);
        try {
            const Url = "/Help/GetHelpUserManual";
            const res = await Axios.get(Url);
            console.log(res.data, "UserManual");
            setObj(res.data);
        } catch (ex) {
            console.log(ex);
        } finally {
            setLoader(false);
        }
    };
    const UserVDOManualsApi = async () => {
        setLoader(true);
        try {
            const Url = "/Help/GetHelpUserVdo";
            const res = await Axios.get(Url);
            console.log(res.data, "UserManual");
            setVideos(res.data);
        } catch (ex) {
            console.log(ex);
        } finally {
            setLoader(false);
        }
    };
    useEffect(() => {
        UserPDFManualsApi();
        UserVDOManualsApi();
    }, []);
    console.log(obj, "UserManual");
    // Group and sort by serial
    const groupedData = Object.values(
        obj.reduce((acc, item) => {
            if (!acc[item.ParentMenu]) {
                acc[item.ParentMenu] = {
                    serial: item.serial,
                    parentMenu: item.ParentMenu,
                    items: [],
                };
            }
            acc[item.ParentMenu].items.push(item);
            return acc;
        }, {})
    ).sort((a, b) => a.serial - b.serial);
    const handleDownload = (menuItem) => {
        const link = document.createElement("a");
        window.open(menuItem.pdfUrl);
        // link.href = menuItem.pdfUrl;
        link.download = `${menuItem.Menu}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const downloadBodyTemplate = (rowData) => (
        <button className="grid-icon">
            <Fa.FaDownload onClick={() => handleDownload(rowData)} />
        </button>
    );
    // Extract categories dynamically
    const categories = [...new Set(videos.map((v) => v.category))].map((c) => ({
        label: c,
        value: c,
    }));
    // Filter videos
    const filteredVideos = videos.filter(
        (v) =>
            (!search ||
                v.title.toLowerCase().includes(search.toLowerCase()) ||
                v.description.toLowerCase().includes(search.toLowerCase())) &&
            (!category || v.category === category)
    );

    // Paginate
    const paginatedVideos = filteredVideos.slice(first, first + rows);
    function getEmbedUrl(youtubeUrl) {
        if (!youtubeUrl) return "";

        // Case 0: Already an embed link
        if (youtubeUrl.includes("youtube.com/embed/")) {
            return youtubeUrl;
        }

        let videoId = "";

        // Case 1: Short link https://youtu.be/VIDEO_ID
        if (youtubeUrl.includes("youtu.be/")) {
            videoId = youtubeUrl.split("youtu.be/")[1];
        }

        // Case 2: Normal link https://www.youtube.com/watch?v=VIDEO_ID
        else if (youtubeUrl.includes("watch?v=")) {
            const urlParams = new URLSearchParams(new URL(youtubeUrl).search);
            videoId = urlParams.get("v");
        }

        return `https://www.youtube.com/embed/${videoId}`;
    }
    // Extract YouTube thumbnail
    const getThumbnail = (url) => {
        if (!url) return "";
        let videoId = "";
        if (url.includes("youtu.be/")) {
            videoId = url.split("youtu.be/")[1].split("?")[0];
        } else if (url.includes("watch?v=")) {
            videoId = new URL(url).searchParams.get("v");
        } else if (url.includes("embed/")) {
            videoId = url.split("embed/")[1].split("?")[0];
        }
        return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
    };

    if (loader) {
        return (<Loader />);
    }
    else {
        return (
            <main>
                <div className="row d-flex justify-content-end align-items-center">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Help</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="text-end">
                            <label className="form-label">Manual Type :</label>
                            <div className="d-inline-flex flex-wrap ms-3">
                                <div className="flex d-inline-flex">
                                    <RadioButton inputId="UserManualPDF" name="PDF" value="PDF" onChange={(e) => setManualType(e.value)} checked={manualType === "PDF"} />
                                    <label htmlFor="UserManualPDF" className="ms-2">PDF</label>
                                </div>
                                <div className="flex d-inline-flex ms-3">
                                    <RadioButton inputId="UserManualVDO" name="Video" value="Video" onChange={(e) => setManualType(e.value)} checked={manualType === "Video"} />
                                    <label htmlFor="UserManualVDO" className="ms-2">Video</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {manualType === "PDF" &&
                    <div className="col-12 pt-0 pb-4">

                        <section className="Tab-Pannel">
                            <div style={{ display: "flex", gap: "20px" }}>
                                {[0, 1].map((columnIndex) => (
                                    <div key={columnIndex} style={{ flex: 1 }}>
                                        <Accordion>
                                            {groupedData
                                                .filter((_, idx) => idx % 2 === columnIndex) // Split into 2 columns
                                                .map((group) => (
                                                    <AccordionTab key={group.parentMenu} header={`${group.parentMenu}`}>
                                                        <div className="DataTable">
                                                            <DataTable
                                                                value={Array.isArray(group.items) ? group.items : []}
                                                                responsiveLayout="scroll"
                                                                filterDisplay="row"
                                                                scrollHeight="40vh"
                                                                scrollable
                                                            >
                                                                <Column
                                                                    field="Menu"
                                                                    header="Manuals"
                                                                    filter
                                                                    filterMatchMode="contains"
                                                                    filterPlaceholder="Search Here..."
                                                                />
                                                                <Column body={downloadBodyTemplate} header="Action" className="text-end Right_Column" />
                                                            </DataTable>
                                                        </div>
                                                    </AccordionTab>
                                                ))}
                                        </Accordion>
                                    </div>
                                ))}
                            </div>
                        </section>

                        {/* <section className="Tab-Pannel">
                    <div className="col-12" style={{ columnCount: 2 }}>
                    <Accordion activeIndex={[0]}>
                        {groupedData.map((group) => (
                            <AccordionTab key={group.parentMenu} header={`${group.serial}. ${group.parentMenu}`}>
                                <div className="DataTable">
                                    <DataTable value={Array.isArray(group.items) ? group.items : []} responsiveLayout="scroll" filterDisplay="row">
                                        <Column field="Menu" header="Manuals" filter filterMatchMode="contains" filterPlaceholder="Search Here..." />
                                        <Column body={downloadBodyTemplate} header="Action" />
                                    </DataTable>
                                </div>
                            </AccordionTab>
                        ))}
                    </Accordion>
                    </div>
                </section> */}
                    </div>
                }
                {manualType === "Video" &&
                    <section className="HelpVideos">
                        <div className="sales-box">
                            {/* Search + Filter */}
                            <div className="row mb-3">
                                <div className="col-lg-6 col-md-12 col-sm-12">
                                    <span className="p-input-icon-left w-50">
                                        <i className="pi pi-search" />
                                        <InputText
                                            placeholder="Search videos by title..."
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                        />
                                    </span>
                                </div>
                                <div className="col-lg-6 col-md-12 col-sm-12">
                                    <div className="text-end">
                                        <Dropdown
                                            value={category}
                                            options={categories}
                                            onChange={(e) => setCategory(e.value)}
                                            placeholder="Filter by category"
                                            showClear
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Grid of videos */}
                            <div className="p-grid">
                                <div className="row">
                                    {paginatedVideos.map((video, index) => (
                                        <div key={index} className="col-lg-4 col-md-6 col-sm-12">
                                            <Card title={video.title} subTitle={video.description}
                                                footer={
                                                    <button type="button" className="btn btn-primary" onClick={() => setSelectedVideo(video)}><Fa.FaPlay className="me-2" /> Watch</button>
                                                    // <Button
                                                    //     label="Watch"
                                                    //     icon="pi pi-play"
                                                    //     onClick={() => setSelectedVideo(video)}
                                                    // />
                                                }
                                            >
                                                <img
                                                    src={getThumbnail(video.url)}
                                                    alt={video.title}
                                                    className="card-thumbnail shadow-2"
                                                />
                                                {/* <iframe width="100%" height="160" src={getEmbedUrl(video.url)} title={video.title} frameBorder="0" allowFullScreen></iframe> */}
                                                <p className="tag"><i className="pi pi-tag"></i> {video.category}</p>
                                            </Card>
                                        </div>
                                    ))}

                                </div>
                            </div>
                            <hr></hr>
                            {/* Pagination */}
                            <Paginator
                                className="paginator"
                                first={first}
                                rows={rows}
                                totalRecords={filteredVideos.length}
                                rowsPerPageOptions={[3, 6, 9, 12]}
                                onPageChange={(e) => {
                                    setFirst(e.first);
                                    setRows(e.rows);
                                }}
                            />

                            {/* Modal for video */}
                            <Dialog
                                header={selectedVideo?.title}
                                visible={!!selectedVideo}
                                style={{ width: "80vw" }}
                                modal
                                onHide={() => setSelectedVideo(null)}
                            >
                                {selectedVideo && (
                                    <iframe
                                        width="100%"
                                        height="400"
                                        src={getEmbedUrl(selectedVideo.url)}
                                        title={selectedVideo.title}
                                        frameBorder="0"
                                        allow="autoplay; encrypted-media"
                                        allowFullScreen
                                    ></iframe>
                                )}
                            </Dialog>
                        </div>
                    </section>
                }
            </main>
        );
    }
};

export default Help;
